module.exports = __webpack_public_path__ + "img/full2-min.68c4aec9.png";